export default __webpack_public_path__ + "static/media/uncertaintyRockBehaviour.3bda3d88.png";